import { StyleSheet } from 'aphrodite';
import { THEME } from '../../Theme/theme';

export const s = StyleSheet.create({
	container: {
		display: 'flex',
		flexDirection: 'column',
		height: '100%',
		overflow: 'hidden',
	},
	controls: {
		display: 'flex',
		alignItems: 'center',
		gap: THEME.spacing.md,
		flexWrap: 'wrap',
		padding: `0 0 ${THEME.spacing.md}px`,
		flexShrink: 0,
	},
	searchInput: {
		flex: 1,
		minWidth: 200,
	},
	results: {
		flex: 1,
		overflowY: 'auto',
		...THEME.common.scrollBar,
	},
	previewSection: {
		display: 'flex',
		flexDirection: 'column',
		height: '100%',
		gap: THEME.spacing.md,
	},
	previewImageContainer: {
		flex: 1,
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		backgroundColor: THEME.colors.background.main,
		borderRadius: THEME.common.borderRadius,
		overflow: 'hidden',
		minHeight: 0,
	},
	previewImage: {
		maxWidth: '100%',
		maxHeight: '100%',
		objectFit: 'contain',
	},
	previewNameRow: {
		display: 'flex',
		alignItems: 'center',
		gap: THEME.spacing.sm,
		flexShrink: 0,
	},
	previewNameInput: {
		flex: 1,
	},
	previewActions: {
		display: 'flex',
		justifyContent: 'flex-end',
		alignItems: 'center',
		gap: THEME.spacing.sm,
		flexShrink: 0,
	},
	removeAction: {
		marginRight: 'auto',
	},
	confirmPrompt: {
		marginRight: 'auto',
		fontSize: THEME.typography.fontSizes.sm,
		color: THEME.colors.text.light,
	},
});
